/** Build-time configuration (Vite env). Only VITE_* values are ever exposed to the browser. */
const e = import.meta.env;

export const env = {
  mock: e.VITE_MOCK === '1' || e.VITE_MOCK === 'true',
  supabaseUrl: (e.VITE_SUPABASE_URL as string | undefined) ?? '',
  supabaseAnonKey: (e.VITE_SUPABASE_ANON_KEY as string | undefined) ?? '',
  stripeKey: (e.VITE_STRIPE_PUBLISHABLE_KEY as string | undefined) ?? '',
  siteUrl: ((e.VITE_SITE_URL as string | undefined) ?? 'https://flylowops.com').replace(/\/$/, ''),
} as const;

/** True when the real backend is configured. Without it (and without mock) the app shows a setup screen. */
export const configured = env.mock || (Boolean(env.supabaseUrl) && Boolean(env.supabaseAnonKey));
